var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mobileHeader", attrs: { id: "mobileHeader" } },
    [
      _c("div", { staticClass: "top-wrapper" }, [
        _c("div", { staticClass: "top" }, [
          _c("img", {
            staticClass: "menu-icon",
            attrs: {
              id: "open-menu",
              src: require("@/assets/img/icon/menu.png"),
              alt: "",
            },
            on: { click: _vm.openHamburgerMenu },
          }),
          _c("img", {
            staticClass: "logo",
            attrs: { src: _vm.getLogoImgUrl(), alt: "" },
          }),
          !["zh_hk"].includes(_vm.language)
            ? _c(
                "div",
                { staticClass: "mobile-lang-block" },
                [
                  _c("langSelectedBlock", {
                    ref: "langSelectedBlock",
                    attrs: { "is-open-lang": _vm.isOpenLang },
                    on: {
                      getOpenLangStatus: _vm.getOpenLangStatus,
                      "update:isOpenLang": function ($event) {
                        _vm.isOpenLang = $event
                      },
                      "update:is-open-lang": function ($event) {
                        _vm.isOpenLang = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isOpenLang
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "on-click-outside",
                      rawName: "v-on-click-outside",
                      value: _vm.closeLangBlock,
                      expression: "closeLangBlock",
                    },
                  ],
                  staticClass: "lang-group",
                },
                [
                  _c("langSelectList", {
                    on: { getLangSelected: _vm.getLangSelected },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "on-click-outside",
              rawName: "v-on-click-outside",
              value: _vm.closeHamburgerMenu,
              expression: "closeHamburgerMenu",
            },
          ],
          staticClass: "dropdown-menu-bg",
          class: { isOpenHamburgerMenu: _vm.isOpenMenu },
        },
        [
          _c("ul", { staticClass: "parent" }, [
            _c("li", { staticClass: "close" }, [
              _c("img", {
                staticClass: "close-menu",
                attrs: { src: require("@/assets/img/icon/close.png"), alt: "" },
                on: { click: _vm.closeHamburgerMenu },
              }),
            ]),
            _c("li", [
              _c(
                "div",
                { staticClass: "mobile-login-block" },
                [_c("loginBlock")],
                1
              ),
            ]),
            _c("li", [_c("recordBlockComponent")], 1),
            _c(
              "li",
              {
                staticStyle: { position: "relative" },
                on: { click: _vm.toggleSettingList },
              },
              [
                _c("img", {
                  staticClass: "arrow-icon",
                  class: { transform180: _vm.isOpenSetting },
                  attrs: {
                    src: require("@/assets/img/icon/expand.png"),
                    alt: "",
                  },
                }),
                _c("settingSelectedBlock", {
                  ref: "settingSelectedBlock",
                  attrs: { "is-open-setting": _vm.isOpenSetting },
                  on: {
                    getOpenSettingStatus: _vm.getOpenSettingStatus,
                    "update:isOpenSetting": function ($event) {
                      _vm.isOpenSetting = $event
                    },
                    "update:is-open-setting": function ($event) {
                      _vm.isOpenSetting = $event
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _vm.isOpenSetting ? _c("settingSelectList") : _vm._e(),
          _c(
            "div",
            {
              staticClass: "version-block",
              class: { resetPosition: _vm.isOpenSetting },
            },
            [_vm._v("Version: " + _vm._s(_vm.version))]
          ),
        ],
        1
      ),
      _c("div", {
        staticClass: "cover-bg",
        class: {
          showIsOpenMenu: _vm.isOpenMenu,
          showIsOpenLang: _vm.isOpenLang,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }